import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Icon, D } from "./icons";

/** «Найти транспорт | Найти грузы» — one search page, two modes (`/search?mode=transport|loads`). */
export default function ModeTabs({ mode }) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const go = (m) => {
    if (m === mode) return;
    const q = params.get("q");
    navigate(`/search?mode=${m}${q && m === "loads" ? `&q=${encodeURIComponent(q)}` : ""}`, { replace: true });
  };
  return (
    <div className="mode-tabs" role="tablist" aria-label="Что искать">
      <button type="button" role="tab" aria-selected={mode === "transport"} className={mode === "transport" ? "active" : ""} onClick={() => go("transport")}>
        <Icon d={D.truck} />
        Найти транспорт
      </button>
      <button type="button" role="tab" aria-selected={mode === "loads"} className={mode === "loads" ? "active" : ""} onClick={() => go("loads")}>
        <Icon d={D.box} />
        Найти грузы
      </button>
    </div>
  );
}
